import React from 'react';
import Item from "../../components/list/Item";
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="The Culture Map"
        desc="Decoding how people think, lead, and get things done across cultures."
        image="/images/books/the-culture-map.jpg"
        pageType="book"
        author="Erin Meyer"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/the-culture-map.jpg"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                The Culture Map
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Erin Meyer</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Erin Meyer draws on years of research and consulting experience to map out eight
                dimensions where cultural differences play out in the workplace — from communication
                styles and feedback norms to decision-making and trust-building. Through vivid
                real-world stories, she shows how misunderstandings between cultures can derail
                projects and teams, and offers practical frameworks for navigating these differences
                effectively.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                For engineers working on distributed, global teams this book is especially relevant.
                Understanding why a colleague gives feedback differently or approaches scheduling
                with a different mindset can transform collaboration. Join us as we explore how
                cultural awareness makes us better teammates and communicators.
              </p>

            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
